import { styled } from "@mui/material";

const OtpInput = styled("input")`
  width: 20%;
  height: 80px;
  text-align: center;
  font-size: 24px;
  border: 2px solid #cccccc;
  border-radius: 4px;
  color: #007cbf;
  outline: none;
  font-weight: 600;
  &:focus {
    caret-color: black;
    border: 2px solid #ff9800;
  }
`;

const DigitsContainer = styled("div")`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin: 8px 0px;
`;

const OtpBody = styled("section")`
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export { OtpInput, DigitsContainer, OtpBody };
